export default {
  // list
  'container_transport_order.column.orderId': 'orderId',
  'container_transport_order.column.ladingOrderId': 'ladingOrderId',
  'container_transport_order.column.transportNo': 'transportNo',
  'container_transport_order.column.sortNo': 'sortNo',
  'container_transport_order.column.primaryFlag': 'primaryFlag',
  'container_transport_order.column.transportType': 'transportType',
  'container_transport_order.column.transportCompanyId': 'transportCompany',
  'container_transport_order.column.transportCompanyName': 'transportCompanyName',
  'container_transport_order.column.transportTime': 'transportTime',
  'container_transport_order.column.shippingTerms': 'shippingTerms',
  'container_transport_order.column.settlementMethod': 'settlementMethod',
  'container_transport_order.column.businessType': 'businessType',
  'container_transport_order.column.loadingPoint': 'loadingPoint',
  'container_transport_order.column.loadingContactName': 'loadingContactName',
  'container_transport_order.column.loadingContactPhone': 'loadingContactPhone',
  'container_transport_order.column.unloadingPoint': 'unloadingPoint',
  'container_transport_order.column.unloadingContactName': 'unloadingContactName',
  'container_transport_order.column.unloadingContactPhone': 'unloadingContactPhone',
  'container_transport_order.column.entrepotId': 'entrepotId',
  'container_transport_order.column.stopArea': 'stopArea',
  'container_transport_order.column.createBy': 'createBy',
  'container_transport_order.column.updateBy': 'updateBy',
  'container_transport_order.column.createTime': 'createTime',
  'container_transport_order.column.updateTime': 'updateTime',
  'container_transport_order.column.dataSource': 'dataSource',
  'container_transport_order.column.remark': 'remark',
  'container_transport_order.column.status': 'status',
  // edit
  'container_transport_order.edit.title': 'Edit ContainerTransportOrder',
  'container_transport_order.add.title': 'Add ContainerTransportOrder',
  'container_transport_order.edit.success': 'Edit Successful',
  'container_transport_order.add.success': 'Add Successful',
  'container_transport_order.form.orderId.required': 'orderId cannot be null',
  'container_transport_order.form.ladingOrderId.required': 'ladingOrderId cannot be null',
  'container_transport_order.form.sortNo.required': 'sortNo cannot be null',
  'container_transport_order.form.primaryFlag.required': 'primaryFlag cannot be null',
  'container_transport_order.form.transportType.required': 'transportType cannot be null',
  'container_transport_order.form.transportCompanyId.required': 'transportCompany cannot be null',
  'container_transport_order.form.transportCompanyName.required': 'transportCompanyName cannot be null',
  'container_transport_order.form.transportTime.required': 'transportTime cannot be null',
  'container_transport_order.form.businessType.required': 'businessType cannot be null',
  'container_transport_order.form.loadingPoint.required': 'loadingPoint cannot be null',
  'container_transport_order.form.unloadingPoint.required': 'unloadingPoint cannot be null',
  'container_transport_order.form.orderId': 'orderId',
  'container_transport_order.form.orderId.placeholder': 'Enter orderId',
  'container_transport_order.form.ladingOrderId': 'ladingOrderId',
  'container_transport_order.form.ladingOrderId.placeholder': 'Enter ladingOrderId',
  'container_transport_order.form.sortNo': 'sortNo',
  'container_transport_order.form.sortNo.placeholder': 'Enter sortNo',
  'container_transport_order.form.primaryFlag': 'primaryFlag',
  'container_transport_order.form.primaryFlag.placeholder': 'Enter primaryFlag',
  'container_transport_order.form.transportType': 'transportType',
  'container_transport_order.form.transportType.placeholder': 'Enter transportType',
  'container_transport_order.form.transportCompanyId': 'transportCompanyId',
  'container_transport_order.form.transportCompanyId.placeholder': 'Enter transportCompanyId',
  'container_transport_order.form.transportCompanyName': 'transportCompanyName',
  'container_transport_order.form.transportCompanyName.placeholder': 'Enter transportCompanyName',
  'container_transport_order.form.transportTime': 'transportTime',
  'container_transport_order.form.transportTime.placeholder': 'Enter transportTime',
  'container_transport_order.form.shippingTerms': 'shippingTerms',
  'container_transport_order.form.shippingTerms.placeholder': 'Enter shippingTerms',
  'container_transport_order.form.settlementMethod': 'settlementMethod',
  'container_transport_order.form.settlementMethod.placeholder': 'Enter settlementMethod',
  'container_transport_order.form.businessType': 'businessType',
  'container_transport_order.form.businessType.placeholder': 'Enter businessType',
  'container_transport_order.form.loadingPoint': 'loadingPoint',
  'container_transport_order.form.loadingPoint.placeholder': 'Enter loadingPoint',
  'container_transport_order.form.loadingContactName': 'loadingContactName',
  'container_transport_order.form.loadingContactName.placeholder': 'Enter loadingContactName',
  'container_transport_order.form.loadingContactPhone': 'loadingContactPhone',
  'container_transport_order.form.loadingContactPhone.placeholder': 'Enter loadingContactPhone',
  'container_transport_order.form.unloadingPoint': 'unloadingPoint',
  'container_transport_order.form.unloadingPoint.placeholder': 'Enter unloadingPoint',
  'container_transport_order.form.unloadingContactName': 'unloadingContactName',
  'container_transport_order.form.unloadingContactName.placeholder': 'Enter unloadingContactName',
  'container_transport_order.form.unloadingContactPhone': 'unloadingContactPhone',
  'container_transport_order.form.unloadingContactPhone.placeholder': 'Enter unloadingContactPhone',
  'container_transport_order.form.entrepotId': 'entrepotId',
  'container_transport_order.form.entrepotId.placeholder': 'Enter entrepotId',
  'container_transport_order.form.stopArea': 'stopArea',
  'container_transport_order.form.stopArea.placeholder': 'Enter stopArea',
}
